/**
 * The default store is js-cookie, or as sugested, Cookies.
 * All stores must implement the following interface:
 * const store = {
 *   get(tokenName, options) {
 *      return token | false
 *   },
 *   set(tokenName, token, options) {
 *   },
 *   remove(tokenName, options) {
 *   }
 * }
 */
import Cookies from 'js-cookie';

export default Cookies;
